import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique des cookies</h1>
        <div className="prose prose-blue max-w-none">
          <p>Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <h2>1. Qu'est-ce qu'un cookie ?</h2>
          <p>
            Un cookie est un petit fichier texte stocké sur votre appareil lors de la visite d'un site web.
          </p>

          <h2>2. Types de cookies utilisés</h2>
          <h3>Cookies nécessaires</h3>
          <p>
            Ces cookies sont essentiels au fonctionnement du site.
          </p>

          <h3>Cookies analytiques</h3>
          <p>
            Ces cookies nous aident à comprendre comment les visiteurs interagissent avec le site.
          </p>

          <h3>Cookies marketing</h3>
          <p>
            Ces cookies sont utilisés pour le ciblage publicitaire.
          </p>

          <h2>3. Gestion des cookies</h2>
          <p>
            Vous pouvez gérer vos préférences en matière de cookies à tout moment via notre bannière de cookies.
          </p>

          <h2>4. Durée de conservation</h2>
          <p>
            Les cookies ont des durées de vie variables selon leur type et leur utilisation.
          </p>

          <h2>5. Vos droits</h2>
          <p>
            Vous avez le droit de refuser les cookies non essentiels.
          </p>
        </div>
      </main>
    </div>
  );
}